import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

/** 旧 /ads/ugc と同じく、有料契約（またはカード登録免除）の組織だけが開ける */
const guard: V2Guard = { kind: 'card' };

/** この担当が新UIで作り直した画面の経路（旧 /ads/ugc・/ads/ugc/:projectId と同じ形） */
const routes: V2Route[] = [
  { path: 'ads/ugc', Component: React.lazy(() => import('./UgcListPage')), guard },
  { path: 'ads/ugc/:projectId', Component: React.lazy(() => import('./UgcEditorPage')), guard },
];

export default routes;
